var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 14 14"}},[_c('g',{attrs:{"fill":_vm.disabled ? _vm.colors.disabled : _vm.colors.main}},[_c('circle',{attrs:{"cx":"1.5","cy":"7","r":"1.5"}}),_c('circle',{attrs:{"cx":"7","cy":"7","r":"1.5"}}),_c('circle',{attrs:{"cx":"12.5","cy":"7","r":"1.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }